import styled from "styled-components";

export const Logo = styled.img`
  height: 6vh;
  margin-right: 1rem;
  @media (max-width: 768px) {
    margin-right: 0.5rem;
  }
`;
